import React, { useState, useEffect, useRef } from 'react'
import FullCalendar from '@fullcalendar/react'
import { BASE_OPTION_REFINERS } from '@fullcalendar/core'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import FlashAlert from '../flash-alert'
import Modal from 'react-bootstrap-modal'
import Pikaday from 'pikaday'
import { ajaxPost } from '../../ajax'

const Calendar = props => {
  BASE_OPTION_REFINERS.schedulerLicenseKey = String

  const [viewTitle, setViewTitle] = useState()
  const [alert, setAlert] = useState(null)
  const [picker, setPicker] = useState()

  const calendarRef = useRef(null)

  const handleDateChange = dateInfo => {
    if (dateInfo.view.type == 'resourceTimeGridDay') {
      setViewTitle(moment(dateInfo.start).format('dddd, MMMM D, YYYY'))
    } else {
      setViewTitle(dateInfo.view.title)
    }

    props.onEventSelect()
    props.onDateChange(dateInfo)
  }

  const handleEventClicked = eventData => {
    props.onEventSelect(eventData.event._def.publicId)
    const selected = document.getElementsByClassName('selected')
    if (selected.length)
      selected[0].classList.remove('selected')

    eventData.el.classList.add('selected')
  }

  const handleSelectionConfirm = () => {
    if (props.selectedEventId) {
      const params = { to_reservation: props.selectedEventId }
      ajaxPost(`/admins/player_reservations/${props.id}/link_to.json`, params)
      .then(response => response.json())
      .then(json => {
        if (json.alert)
          setAlert(json.alert)
        else
          props.onLinked(json)
      })
    }
  }

  useEffect(() => {
    const datePickerButton = document.querySelector('.fc-datePickerTitleModal-button')

    if (datePickerButton) {
      setPicker(
        new Pikaday({
          field: datePickerButton,
          onSelect: (date) => { calendarRef.current.getApi().gotoDate(moment(date).format('YYYY-MM-DD')) }
        })
      )
    }
  }, [])

  return (
    <Modal backdrop='static' container={document.body} id='changeReservationModal' show={true} onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Link Payment to another reservation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
        <div className='reservation-calendar__panel'>
          <div id='calendar-modal'>
            <FullCalendar
              schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
              allDaySlot={false}
              nowIndicator={true}
              plugins={ [resourceTimeGridPlugin] }
              initialView={'resourceTimeGridDay'}
              headerToolbar={{
                start: 'prev,next today',
                center: 'datePickerTitleModal',
                end: 'resourceTimeGridDay'
              }}
              customButtons={{
                datePickerTitleModal: {
                  text: viewTitle,
                  click: () => {picker && picker.show()}
                }
              }}
              views={{
                resourceTimeGridDay: {
                  titleFormat: {
                    month: 'long',
                    year: 'numeric',
                    day: 'numeric',
                    weekday: 'long'
                  }
                }
              }}
              nextDayThreshold='09:00:00'
              timeZone='local'
              initialDate={props.date}
              resources={props.fieldsData['simple']}
              contentHeight={window.innerHeight - 400}
              dayMaxEventRows={true}
              slotMinTime={props.minTime ? props.minTime : '00:00:00'}
              slotMaxTime={props.maxTime ? props.maxTime : '24:00:00'}
              scrollTime='17:00:00'
              slotDuration='00:15:00'
              slotLabelInterval='00:30:00'
              eventDisplay='block'
              datesSet={(dateInfo) => {handleDateChange(dateInfo)}}
              eventClick={(eventData) => {handleEventClicked(eventData)}}
              ref={calendarRef}
              events={props.events}
            />
          </div>
          <button
            className='btn btn-info confirm-link'
            disabled={props.selectedEventId ? false : true}
            onClick={handleSelectionConfirm}
          >
              Confirm
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default Calendar
